var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDeliveryOrder(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "delivery (2)",
    clipPath: "url(#clip0_849_14757)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M57.3992 45.1848C52.1167 45.1848 47.8193 49.4822 47.8193 54.7647C47.8193 60.0471 52.1167 64.3445 57.3992 64.3445C62.6825 64.3445 66.9791 60.0471 66.9791 54.7647C66.9791 49.4822 62.6816 45.1848 57.3992 45.1848ZM57.3992 59.5546C54.7576 59.5546 52.6093 57.4063 52.6093 54.7647C52.6093 52.1231 54.7576 49.9747 57.3992 49.9747C60.0408 49.9747 62.1891 52.1231 62.1891 54.7647C62.1891 57.4064 60.0408 59.5546 57.3992 59.5546Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M24.6682 45.1848C19.3858 45.1848 15.0884 49.4822 15.0884 54.7647C15.0884 60.0471 19.3858 64.3445 24.6682 64.3445C29.9507 64.3445 34.2481 60.0471 34.2481 54.7647C34.2481 49.4822 29.9507 45.1848 24.6682 45.1848ZM24.6682 59.5546C22.0266 59.5546 19.8783 57.4063 19.8783 54.7647C19.8783 52.1231 22.0266 49.9747 24.6682 49.9747C27.3091 49.9747 29.4582 52.1231 29.4582 54.7647C29.4582 57.4064 27.3098 59.5546 24.6682 59.5546Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M63.8505 17.7642C63.4433 16.9556 62.6155 16.4454 61.7102 16.4454H49.0967V21.2353H60.2332L66.7547 34.2064L71.0353 32.054L63.8505 17.7642Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M50.2141 52.4496H32.0923V57.2396H50.2141V52.4496Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_9"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M17.4829 52.4496H9.18054C7.85766 52.4496 6.78564 53.5218 6.78564 54.8445C6.78564 56.1674 7.85781 57.2394 9.18054 57.2394H17.4831C18.806 57.2394 19.878 56.1673 19.878 54.8445C19.878 53.5217 18.8058 52.4496 17.4829 52.4496Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_11"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M75.4969 37.8084L70.7861 31.7411C70.3335 31.1567 69.635 30.815 68.8949 30.815H51.4915V14.0503C51.4915 12.7275 50.4193 11.6555 49.0966 11.6555H9.18054C7.85766 11.6555 6.78564 12.7276 6.78564 14.0503C6.78564 15.3731 7.85781 16.4452 9.18054 16.4452H46.7015V33.2099C46.7015 34.5328 47.7737 35.6048 49.0964 35.6048H67.7221L71.2099 40.0977V52.4493H64.5838C63.2609 52.4493 62.1889 53.5215 62.1889 54.8442C62.1889 56.1671 63.2611 57.2391 64.5838 57.2391H73.6048C74.9277 57.2391 75.9997 56.167 75.9998 54.8442V39.2773C75.9998 38.7456 75.8226 38.2283 75.4969 37.8084Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_13"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M17.3234 40.3152H6.30651C4.98364 40.3152 3.91162 41.3873 3.91162 42.7101C3.91162 44.033 4.98378 45.105 6.30651 45.105H17.3232C18.6461 45.105 19.7181 44.0328 19.7181 42.7101C19.7183 41.3873 18.6461 40.3152 17.3234 40.3152Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_15"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M22.8319 30.8949H2.39489C1.07216 30.8949 0 31.9671 0 33.2899C0 34.6128 1.07216 35.6848 2.39489 35.6848H22.8319C24.1548 35.6848 25.2268 34.6127 25.2268 33.2899C25.2268 31.9672 24.1548 30.8949 22.8319 30.8949Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_17"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_18"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M26.7435 21.4747H6.30651C4.98364 21.4747 3.91162 22.5469 3.91162 23.8696C3.91162 25.1925 4.98378 26.2645 6.30651 26.2645H26.7435C28.0664 26.2645 29.1384 25.1923 29.1384 23.8696C29.1386 22.5469 28.0664 21.4747 26.7435 21.4747Z",
    fill: "black"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_849_14757"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 76,
    height: 76,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeliveryOrder);
export default __webpack_public_path__ + "static/media/deliveryOrder.c0acc92169392331ba6105b75bafa6d2.svg";
export { ForwardRef as ReactComponent };